// 阿里云图形认证 appId，在控制台「图形认证方案管理」中创建 H5 方案后获取
export const ALIYUN_CAPTCHA_ID = "02c4d8df9642871bca43539ddfe5f531";



// WEBPACK FOOTER //
// ./src/js/aliyunCaptchaConfig.js